// extracted by mini-css-extract-plugin
export default {"list":"sort-settings_list__dSXvl","navElem":"sort-settings_navElem__ql3Rg"};